<template>
<div>
  <div class="referralBtn">
    <button @click="jobSeekerPage" class="button is-primary is-fullwidth">
        VIEW PROFILE
    </button>
  </div>
  <div class="referralBtn">
    <button @click="removeItem" class="button is-primary is-fullwidth is-inverted inverted-border">
        REMOVE REFERRAL
    </button>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: { mapState },
  props: {
    itemindex: {
      type: [Number, null],
      required: false,
      default: -1
    },
    userid: {
      type: [String, null],
      required: false,
      default: ''
    }
  },
  methods: {
    removeItem () {
      this.$store.dispatch('jobReferral/removeReferal', this.itemindex)
      this.$store.dispatch('jobReferral/deleterefferal', { itemindex: this.itemindex, userid: this.userid, confirmation: false })
    },
    jobSeekerPage () {
      this.$store.dispatch('jobReferral/deleterefferal', { itemindex: null, userid: null, confirmation: false })
      window.open('/jobseekers/' + this.userid, '_blank')
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.inverted-border, .inverted-border:hover  {
  border-color: $brand-primary;
}
.referralBtn:not(:last-child) {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/referrals/referral-remove-modal.vue